// removed by extract-text-webpack-plugin
module.exports = {"tagSelect":"antd-pro-tagSelect","expand":"antd-pro-expand","fold":"antd-pro-fold","trigger":"antd-pro-trigger","expandTag":"antd-pro-expandTag"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/TagSelect/index.less
// module id = 415
// module chunks = 0 1